import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { showErrorToast } from "src/util/antd.util";
export default new QueryClient({
  queryCache: new QueryCache({
    onError: showErrorToast,
  }),
  mutationCache: new MutationCache({
    onError: showErrorToast,
  }),
  defaultOptions: {
    queries: {
      staleTime: 60_000,
    },
  },
});
